export default __webpack_public_path__ + "static/media/Invoice_active.922a1d4f.svg";